import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";

import { FlexboxGrid } from "@components/common/FlexboxGrid";
import { ScrollContainer } from "@components/ScrollContainer";

import {
    setConfigInformationModes,
    kioskStore as store,
} from "@pages/Kiosk/store";

import { InformationModesCardWrapper } from "./InformationModesCardWrapper";
import { ReactSwitchWrapper } from "./ReactSwitchWrapper";
import { SalesMethodsSelectWrapper } from "./SalesMethodsSelectWrapper";

export function InformationModes(): JSX.Element {
    const { selectedSaleModeValue, localProject, activeTabTitle } =
        useSnapshot(store);

    const [mainContentInformationModes, setMainContentInformationModes] =
        React.useState<ProjectMainContentItemType[]>(
            (
                localProject.template.content
                    .informationModes as ProjectContentItemType
            ).items.filter((item: ProjectMainContentItemType) => {
                return (
                    localProject.template.content
                        .salesMethods as ProjectContentItemType
                ).items
                    .filter((saleMethod) => {
                        return saleMethod.name === selectedSaleModeValue;
                    })[0]
                    ?.informationModes?.items?.includes(item.id);
            })
        );
    const isInformationModeItemsHasOneModeActive =
        (
            localProject.template.content
                .informationModes as ProjectContentItemType
        ).items.filter(
            (item) =>
                (item.active as ItemContentType)[selectedSaleModeValue] === true
        ).length === 1;
    React.useEffect(() => {
        if (selectedSaleModeValue !== "") {
            setMainContentInformationModes(
                (
                    localProject.template.content
                        .informationModes as ProjectContentItemType
                ).items.filter((item: ProjectMainContentItemType) => {
                    return (
                        localProject.template.content
                            .salesMethods as ProjectContentItemType
                    ).items
                        .filter((saleMethod) => {
                            return saleMethod.name === selectedSaleModeValue;
                        })[0]
                        .informationModes?.items?.includes(item.id);
                })
            );
        }
    }, [selectedSaleModeValue, localProject.template.content.informationModes]);

    return (
        <div className="d-flex flex-column" style={{ margin: 30 }}>
            <div
                style={{
                    fontWeight: 600,
                    fontSize: "var(--font-size-subtitle)",
                    color: "var(--font-color-subtitle)",
                    lineHeight: "49px",
                    marginBottom: 30,
                    marginLeft: 23,
                }}
            >
                {activeTabTitle}
            </div>

            <FlexboxGrid className="justify-content-between">
                <SalesMethodsSelectWrapper />
                {selectedSaleModeValue !== "" ? (
                    isInformationModeItemsHasOneModeActive ? (
                        <FlexboxGrid
                            alignItemsCentered={true}
                            className="justify-content-end cursor__clz"
                            gap="20px"
                        >
                            <ReactSwitchWrapper
                                pageName={"informationModes"}
                                selectedSaleModeValue={selectedSaleModeValue}
                            />
                        </FlexboxGrid>
                    ) : null
                ) : null}
            </FlexboxGrid>

            <ScrollContainer
                style={{
                    maxHeight: "880px",
                    overflowY: "auto",
                }}
            >
                <div
                    style={{
                        margin: "30px",
                        gap: "30px",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gridTemplateRows: `repeat(${Math.round(
                            mainContentInformationModes.length / 2
                        )}, 1fr)`,
                    }}
                >
                    {mainContentInformationModes.map(
                        (
                            option: ProjectMainContentItemType,

                            index: number
                        ) => {
                            return (
                                <div key={option.id}>
                                    <span
                                        className="cursor__clz"
                                        style={{
                                            fontSize: "var(--font-size-base)",
                                            lineHeight: "20px",
                                            color: "#B2B2B2",
                                        }}
                                    >
                                        {t(
                                            (
                                                option as ProjectMainContentItemType
                                            ).name as string
                                        )}
                                    </span>
                                    <InformationModesCardWrapper
                                        item={option}
                                        index={index}
                                        key={index}
                                        setConfig={setConfigInformationModes}
                                        setItems={
                                            setMainContentInformationModes
                                        }
                                    />
                                </div>
                            );
                        }
                    )}
                </div>
            </ScrollContainer>
        </div>
    );
}
